// extracted by mini-css-extract-plugin
module.exports = {"bodyM":"theme_bodyM__nT3qn","ui4":"var(--ui4)","textPrimary":"var(--textPrimary)","textarea":"EditNotes_textarea__Fsdh_ theme_bodyM__nT3qn"};